window.showErrorMessage = function() {
  var errorMessage = 'An error occurred – Something went wrong. Please try to reload the page';
  if ($('body').hasClass('de')){
    errorMessage = 'Leider ist etwas schief gelaufen! Bitte laden Sie die Seite neu.';
  }
  var error = $('<div></div>').addClass('alert alert-danger').text(errorMessage);

  $('.flash-container').append(error);
  $('.flash-container').addClass('visible');

  setTimeout(function(){
    if ($('.flash-container > div').length === 1) {
      $('.flash-container').removeClass('visible');
      setTimeout(function() {
        $(error).remove();
      },300);
    }else {
      $(error).remove();
    }
  },2000);
};
$( document ).ajaxError(window.showErrorMessage);

$(document).on('error', window.showErrorMessage)
